import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { PrivateRoute } from "./helpers";
import { LoadingState } from "../components";

import TarsLandingPage from "../features/tars/TarsLandingPage";
import NotebookDetails from "../features/tars/notebook-details/NotebookDetails";
import RequestMethodSelection from "../pages/ServiceRequestScan/requesrmethodselect";
import VoiceRequest from "../pages/ServiceRequestScan/voice-requestpage";
import { ServiceMapRequestDashboard } from "../pages/sr-heatmap/sr-map-dashboard";
import SaudatthiDashboard from "../../public/Saudatti-yellama-dashboard";

// Lazy load all route components
const DashBoardRoutes = lazy(() =>
    import("./analytical-dashboard-routes").then((mod) => ({
        default: mod.DashBoardRoutes,
    }))
);

const RenderFile = lazy(() =>
    import("../features/digital-repository").then((mod) => ({
        default: mod.RenderFile,
    }))
);
const ComparePage = lazy(() => import("../flexistore/renderkeys/social-listeningv2/ComparePage"));
const MultiStepForm = lazy(() => import("../pages/ServiceRequestScan/components/MultiStepFom/MultiStepForm"));
const MultiFormSucessSubmit = lazy(
    () => import("../pages/ServiceRequestScan/components/SubmitForm/MultiFormSucessSubmit")
);
const SocialListeningMainPagev2 = lazy(() =>
    import("../flexistore/renderkeys/social-listeningv2/pages/SocialListeningMainPagev2").then((mod) => ({
        default: mod.SocialListeningMainPagev2,
    }))
);
const JagiroadInsights = lazy(() => import("../pages/ad-hoc-features/JagiroadInsights"));
const DighaCampaign = lazy(() => import("../pages/ad-hoc-features/digha-campaign"));
const ReachoutCampaignsHome = lazy(() =>
    import("../flexistore/renderkeys/reachout-campaigns/reachout-campaigns-home").then((mod) => ({
        default: mod.ReachoutCampaignsHome,
    }))
);

const BkonTenantsPage = lazy(() =>
    import("../new-features/bkon/bkon-ux-v2").then((mod) => ({ default: mod.BkonTenantsPage }))
);
const BkonTenantAccountsPage = lazy(() =>
    import("../new-features/bkon/bkon-ux-v2").then((mod) => ({ default: mod.BkonTenantAccountsPage }))
);
const BkonAccountDashboardPage = lazy(() =>
    import("../new-features/bkon/bkon-ux-v2").then((mod) => ({ default: mod.BkonAccountDashboardPage }))
);
const BkonOpportunityPlaybookPage = lazy(() =>
    import("../new-features/bkon/bkon-ux-v2").then((mod) => ({ default: mod.BkonOpportunityPlaybookPage }))
);

const RamanagaraInsights = lazy(() => import("../pages/ad-hoc-features/RamanagaraInsights"));
const MaduraiNorthFieldLog = lazy(() => import("../pages/ad-hoc-features/MaduraiNorthFieldLog"));
// const BkonDashboard = lazy(() => import("../new-features/bkon"));

const NotFound = lazy(() => import("../pages/NotFound").then((mod) => ({ default: mod.NotFound })));

const BYRBJP = lazy(() => import("../pages/ad-hoc-features/by-bjp"));
const Enquiries = lazy(() => import("../components/Enquiries"));
const DataBankRoutes = lazy(() => import("./databank-routes"));
const ReportRoutes = lazy(() => import("./databank-routes"));
const FeatureRoutes = lazy(() => import("./all-features-routes"));
const ToolsRoutes = lazy(() => import("./tools-routes"));
const CockpitRoutes = lazy(() => import("./cockpit-routes"));
const SLAR = lazy(() => import("../pages/ad-hoc-features/somali-land-president/ar-landing-page"));
const NotionPage = lazy(() => import("../new-features/notion-react-trial"));
const TermsAndConditions = lazy(() => import("../pages/login-pages/terms-condition"));
const PrivacyPolicy = lazy(() => import("../pages/login-pages/privacy-policy"));

const MLAOR = lazy(() => import("../pages/ad-hoc-features/Australia-Mira/miraforlalorar"));
const Portfolio = lazy(() => import("../pages/ad-hoc-features/App-Portfolio/portfolio"));
const SocialFetch = lazy(() => import("../flexistore/renderkeys/social-listening/social-listening-fetch"));
const NewLogin = lazy(() => import("../pages/login-pages/new-login"));
const DeleteUserPage = lazy(() => import("../pages/DeleteUserPage"));
const ProjectDashboardPage = lazy(() => import("../pages/dashboard/ProjectDashboard"));
const SettingsPage = lazy(() => import("../pages/Settings"));
const LlmUsagePage = lazy(() => import("../pages/llm-usage/LlmUsagePage"));
const PBIReportsHome = lazy(() => import("../features/pbi-reports/pbi-reports-home"));
const PBIDashBoardTemplate = lazy(() => import("../features/pbi-reports/pbi-dashboard-template"));

const FacebookLogs = lazy(() => import("../pages/ad-hoc-features/Facebook-Scrap/components/FacebookLogs"));

const ServicePortal = lazy(
    () => import("../pages/ServiceRequestScan/components/ServiceRequestHome/ServicePortal")
);
const SurveyBuilder = lazy(() => import("../features/survey-builder/survey-builder"));
const WebARDemo = lazy(() => import("../pages/web-ar-demo/WebARDemo"));
const UpCasteDashboardPage = lazy(() =>
    import("../pages/UpCasteDashboardPage").then((mod) => ({
        default: mod.default,
    }))
);
const JagiroadInsightsDashboard = lazy(() =>
    import("../pages/JagiroadInsightsDashboard").then((mod) => ({
        default: mod.default,
    }))
);
const DVGSouthInsightsDashboard = lazy(() =>
    import("../pages/DVGSouthInsightsDashboard").then((mod) => ({
        default: mod.default,
    }))
);
const SaundattiYellammaInsightsDashboard = lazy(() =>
    import("../pages/SaundattiYellammaInsightsDashboard").then((mod) => ({
        default: mod.default,
    }))
);
const RnAiAgent = lazy(() => import("../pages/rn-ai-agent"));
const PrintMediaReportsRoutes = lazy(() => import("./print-media-routes"));
const PrintMediaDashboardRoute = lazy(() =>
    import("./print-media-routes").then((mod) => ({ default: mod.PrintMediaDashboardRoute }))
);
const ManageSearchTermsRoute = lazy(() =>
    import("./print-media-routes").then((mod) => ({ default: mod.ManageSearchTermsRoute }))
);

export const MainRoutes = () => {
    // @ts-ignore
    return (
        <Suspense fallback={<LoadingState />}>
            <Routes>
                <Route path={"/login"} element={<NewLogin />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path={"/delete_user_info"} element={<DeleteUserPage />} />
                <Route path={"/enquiries"} element={<Enquiries />} />
                <Route path="/up-caste-dashboard" element={<UpCasteDashboardPage />} />
                <Route path="/jagiroad-dashboard" element={<JagiroadInsightsDashboard />} />
                <Route path="/saudatthi-dashboard" element={<SaudatthiDashboard />} />
                <Route path="/analytics/v3/dvgsouth" element={<DVGSouthInsightsDashboard />} />

                <Route path="/analytics/v3/:slug" element={<SaundattiYellammaInsightsDashboard />} />

                <Route path={"/interview/web/:surveyId"} element={<SurveyBuilder />} />
                <Route path={"/landing/BYRBJP"} element={<BYRBJP />} />
                <Route path={"/musebixi"} element={<SLAR />} />
                <Route path={"/miraforlalor"} element={<MLAOR />} />
                <Route path={"/web-ar-demo"} element={<WebARDemo />} />
                <Route path="/RnAiAgent/*" element={<RnAiAgent />} />
                <Route path="/insights/field/jagiroad" element={<JagiroadInsights />} />
                <Route path="/digha" element={<DighaCampaign />} />
                <Route path="/insights/field/ramanagara" element={<RamanagaraInsights />} />
                <Route path="/madurai-north-field-log" element={<MaduraiNorthFieldLog />} />
                <Route path="/bkon/tenants" element={<BkonTenantsPage />} />
                <Route path="/bkon/tenant/:tenantId" element={<BkonTenantAccountsPage />} />
                <Route
                    path="/bkon/tenant/:tenantId/account/:accountName"
                    element={<BkonAccountDashboardPage />}
                />
                <Route
                    path="/bkon/tenant/:tenantId/account/:accountName/opportunity/:opportunityId"
                    element={<BkonOpportunityPlaybookPage />}
                />
                {/*=======*/}
                {/*                <Route path="/insights/field/jagiroad" element={<JagiroadInsights />} />*/}
                {/*                <Route path="/insights/field/ramanagara" element={<RamanagaraInsights />} />*/}
                {/*                <Route path="/madurai-north-field-log" element={<MaduraiNorthFieldLog />} />*/}
                {/*<Route path="/bkon/:signal" element={<BkonDashboard />} />*/}
                {/*>>>>>>> Stashed changes*/}

                <Route
                    path={"/portfolio"}
                    element={
                        <ParallaxProvider>
                            <Portfolio />
                        </ParallaxProvider>
                    }
                />

                <Route path="/dashboard/*" element={<DashBoardRoutes />} />
                <Route path="/pbidashboard/:key" element={<PBIDashBoardTemplate />} />
                <Route path="/srheatmap" element={<ServiceMapRequestDashboard />} />
                {/* service portal */}
                {/*<Route*/}
                {/*    path="/:cityname/serviceportal"*/}
                {/*    element={<ServicePortal />}*/}
                {/*/>*/}
                <Route path="/serviceportal/:projectid" element={<ServicePortal />} />
                {/*<Route path="/:cityname/serviceportal/multistepform" element={<MultiStepForm />} />*/}
                {/*<Route*/}
                {/*    path="/:cityname/serviceportal/multistepform/successsubmitrequest"*/}
                {/*    element={<MultiFormSucessSubmit />}*/}
                {/*/>*/}
                {/*<Route path="/serviceportal/:projectid/multistepform" element={<MultiStepForm />} />*/}
                {/*<Route path="/serviceportal/:projectid/multistepform" element={<ServicePortal />} />*/}
                <Route
                    path="/serviceportal/:projectid/method-selection"
                    element={<RequestMethodSelection />}
                />

                <Route path="/serviceportal/:projectid/voice-request" element={<VoiceRequest />} />

                <Route
                    path="/serviceportal/:projectid/multistepform/success"
                    element={<MultiFormSucessSubmit />}
                />
                {/*  */}

                <Route path={"/"} element={<PrivateRoute />}>
                    <Route index path="/" element={<ProjectDashboardPage />} />
                    <Route path="/project/:projectid/*" element={<FeatureRoutes />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/llm-usage" element={<LlmUsagePage />} />
                    <Route path="/cockpit/*" element={<CockpitRoutes />} />
                    <Route path="/campaigns" element={<ReachoutCampaignsHome />} />
                    <Route path="/tools/*" element={<ToolsRoutes />} />
                    <Route path="/notion" element={<NotionPage />} />

                    <Route path="/databank/*" element={<DataBankRoutes />} />
                    <Route path="/social_listening" element={<SocialFetch />} />
                    <Route path="/tars" element={<TarsLandingPage />} />
                    <Route path="/tars/:notebookId" element={<NotebookDetails />} />

                    <Route path="/social-report/:name/:whoId" element={<SocialListeningMainPagev2 />} />
                    <Route path="/compare" element={<ComparePage />} />
                    {/*<Route path="/reports/*" element={<ReportRoutes/>}/>*/}
                    <Route path="/reports/*" element={<ReportRoutes />} />
                    <Route path="/bgtasks/*" element={<FacebookLogs />} />
                    <Route path="/view-file/:key" element={<RenderFile />} />
                    <Route path="/pbidashboard" element={<PBIReportsHome />} />
                    <Route path="/media" element={<PrintMediaDashboardRoute />} />
                    <Route path="/manage_search_terms" element={<ManageSearchTermsRoute />} />
                    <Route path="/print_media_reports/*" element={<PrintMediaReportsRoutes />} />
                </Route>
                {/* 404 fallback route - must be last */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};
